import React from 'react'
import ReactDOM from 'react-dom'
import {useDispatch} from "react-redux";
import {languageChange} from '../actions/'

import styles from './LanguageSelect.module.css'

const LanguageSelect = () => {
    const dispatch = useDispatch();

    const handleLanguageChange = (language, e) => {
        e.preventDefault();
        e.stopPropagation();

        localStorage.setItem("language", language);
        dispatch(languageChange(language));
    }

    return (
        <div className={styles.languate_select}>
            <div className={styles.lang} onClick={e => {
                handleLanguageChange("TW", e);
            }}>TC</div>
            <div className={styles.lang} onClick={e => {
                handleLanguageChange("EN", e)
            }}>EN</div>

            <div className={styles.facebook} onClick={() => {
                window.open("https://www.facebook.com/outlandfilmproduction/")
            }}></div>
            <div className={styles.mail} onClick={() => {
                window.open("mailto:outlandfilms@gmail.com")
            }}></div>
        </div>
    );
}

export default LanguageSelect;